import { PropsWithChildren } from 'react';
import { TocProvider } from './TocContext/TocProvider';
import { TocList } from './components/TocList/TocList';

export function Toc({ children }: PropsWithChildren) {
  return (
    <TocProvider>
      <div className='d-flex h-100 w-100'>
        <TocList />

        {children}
      </div>
    </TocProvider>
  );
}
